/* lp-heatmaster.js */
function lpGoForm(){document.getElementById('devis').scrollIntoView({behavior:'smooth'});setTimeout(function(){var f=document.getElementById('lf-name');if(f)f.focus();},650);}
function lpFaq(btn){var qa=btn.parentElement;document.querySelectorAll('.lp-qa.lp-open').forEach(function(o){if(o!==qa)o.classList.remove('lp-open')});qa.classList.toggle('lp-open');}
(function(){
  var lpForm=document.getElementById('lpForm');
  if(lpForm){lpForm.addEventListener('submit',function(e){
    var bad=null;
    lpForm.querySelectorAll('[required]').forEach(function(el){
      var empty=(el.type==='checkbox')?!el.checked:!el.value.trim();
      if(empty&&!bad)bad=el;
      el.style.borderColor='';
    });
    if(bad){e.preventDefault();bad.style.borderColor='var(--lp-orange)';bad.focus();}
  });}
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('lp-in');io.unobserve(e.target)}})},{threshold:.12});
  document.querySelectorAll('.lp-rv:not(.lp-in)').forEach(function(el){io.observe(el)});
  window.addEventListener('scroll',function(){var m=document.getElementById('lpMcta');if(!m)return;if(window.scrollY>520)m.classList.add('lp-show');else m.classList.remove('lp-show');});
})();

/* galerie produit */
(function(){
  var thumbs=document.querySelectorAll('#lpGThumbs .lp-gthumb'),main=document.getElementById('lpGMain');
  if(!thumbs.length||!main) return;
  thumbs.forEach(function(t){t.addEventListener('click',function(){
    var f=t.getAttribute('data-full'); if(f)main.style.backgroundImage="url('"+f+"')";
    thumbs.forEach(function(x){x.classList.remove('is-active');}); t.classList.add('is-active');
  });});
})();
/* bande vivante de recommandation (accueil + produit) */
(function(){
  var L=document.getElementById('lf-long'),W=document.getElementById('lf-larg'),D=document.getElementById('lf-prof');
  if(!(L&&W&&D)) return;
  var models=[]; var el=document.getElementById('lpModels'); if(el){try{models=JSON.parse(el.textContent.trim());}catch(e){}}
  models.sort(function(a,b){return a.vmax-b.vmax;});
  var band=document.getElementById('lpReco'),volEl=document.getElementById('lpVol'),nameEl=document.getElementById('lpRecoName'),hidden=document.getElementById('lpRecoHidden');
  var raf,disp=0;
  function animate(t){cancelAnimationFrame(raf);(function st(){disp+=(t-disp)*0.25;if(Math.abs(t-disp)<0.5)disp=t;if(volEl)volEl.textContent=Math.round(disp);if(disp!==t)raf=requestAnimationFrame(st);})();}
  function cols(on,name){document.querySelectorAll('[data-model]').forEach(function(c){c.classList.toggle('lp-reco-col',!!on&&c.getAttribute('data-model')===name);});}
  function upd(){
    var l=parseFloat(L.value),w=parseFloat(W.value),d=parseFloat(D.value);
    if(!l||!w||!d){animate(0);if(band)band.classList.remove('is-set');if(nameEl)nameEl.textContent='— renseignez vos dimensions';if(hidden)hidden.value='';cols(false);return;}
    var vol=Math.round(l*w*d); animate(vol);
    var pick=null; if(models.length){for(var i=0;i<models.length;i++){if(vol<=models[i].vmax){pick=models[i];break;}} if(!pick)pick=models[models.length-1];}
    if(pick){if(nameEl)nameEl.textContent=pick.name+' · '+pick.kw; if(hidden)hidden.value=pick.name+' ('+pick.kw+') — bassin ~'+vol+' m3'; cols(true,pick.name);}
    else {if(nameEl)nameEl.textContent='Bassin ~'+vol+' m³'; if(hidden)hidden.value='bassin ~'+vol+' m3';}
    if(band){band.classList.remove('is-set');void band.offsetWidth;band.classList.add('is-set');}
  }
  [L,W,D].forEach(function(x){x.addEventListener('input',upd);});
})();
